import BaseListPresenter from "../../../base/BaseListPresenter";

class EmployeeRecordsPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
    this.view = view;
  }
  init() {
    this.employeeIds = this.view.state.employeeIds;
    this.separatedEmployeeIds = null;
    this.findRequestId = 0;
    this.limit = 50;
    this.where = {};
    this.search = {};
    this.filter = {};
    this.include = ["all"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: { ...this.where, ...this.search, ...this.filter },
      include: this.include,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    const keys = this.keys || this.view.getKeys() || [];
    if (keys.length > 0) {
      query.keys = keys;
    }
    return query;
  }

  async findObjects() {
    const requestId = ++this.findRequestId;
    const collection = this.view.getCollectionName();
    const query = this.createQuery();

    try {
      this.showProgress();
      this.findObjectUseCase.abort();

      const employeeIds = await this.ensureSeparatedEmployeeIds();
      if (requestId !== this.findRequestId) return;

      const objects = await this.findObjectUseCase.execute(collection, query);
      if (requestId !== this.findRequestId) return;

      const filteredObjects =
        employeeIds.size > 0
          ? objects.filter((obj) => !employeeIds.has(obj.id))
          : objects;

      filteredObjects.forEach((obj) => {
        if (obj.employmentType?.types === "Plantilla") {
          obj.positionLabel = obj.position?.position_title || "";
        } else if (obj.employmentType?.types === "Non-Plantilla") {
          obj.positionLabel = obj.nonRegPosition?.positionTitle || "";
        }
      });

      this.objects = filteredObjects;
      this.view.setObjects(filteredObjects);
      this.view.setCurrent(this.current);
      this.hideProgress();
    } catch (error) {
      if (requestId !== this.findRequestId) return;
      this.hideProgress();
      this.view.showError(error);
    }
    if (requestId === this.findRequestId) {
      this.progress = false;
    }
  }

  setCurrentPage(page) {
    this.current = page;
    this.documents = [];
    this.view.setCurrent(page);
    this.view.setObjects([]);
    this.findObjects();
  }

  async ensureSeparatedEmployeeIds() {
    if (this.separatedEmployeeIds) {
      return this.separatedEmployeeIds;
    }

    const seperated = await this.findObjectUseCase.execute("seperated", {
      keys: ["employee"],
    });

    this.separatedEmployeeIds = new Set(
      seperated.map((s) => s.employee?.id).filter(Boolean)
    );

    return this.separatedEmployeeIds;
  }

  async fetchSeperatedEmployees() {
    return this.ensureSeparatedEmployeeIds();
  }
}
export default EmployeeRecordsPresenter;
